/**
 * remediationPanelState — regra do painel "Remediar" da Conferência de Entrega.
 *
 * Uma remediação por vez no projeto: enquanto houver execução ativa (ou a que acabou de
 * ser disparada, antes do refetch da última execução), o botão fica bloqueado e o painel
 * mostra o aviso de andamento. Bug de campo (2026-09-17): sem retorno visível, 3 cliques
 * viraram 3 remediações simultâneas.
 */

/** Estados em que a execução ainda está viva (espelha o guard 409 da API). */
export const ACTIVE_EXECUTION_STATUSES = ['pending', 'running', 'gate_waiting'];

export function isExecutionActive(status) {
  return ACTIVE_EXECUTION_STATUSES.includes(status);
}

/**
 * @param {{
 *   latestExec: {executionId?: string, status?: string} | null,
 *   launched: {execution_id?: string} | null,   // resposta do POST /executions/remediate
 *   pending: boolean,                           // POST em andamento
 *   prompt: string,
 *   surface: string,
 * }} input
 * @returns {{ blocked: boolean, activeExecutionId: string|null, canSubmit: boolean }}
 */
export function remediationPanelState({ latestExec, launched, pending, prompt, surface }) {
  const latestId = latestExec?.executionId || null;
  const launchedId = launched?.execution_id || null;

  let activeExecutionId = null;
  if (isExecutionActive(latestExec?.status)) {
    activeExecutionId = latestId;
  } else if (launchedId && launchedId !== latestId) {
    // Acabou de disparar e a "última execução" ainda não refletiu → trata como ativa.
    activeExecutionId = launchedId;
  }

  const blocked = Boolean(activeExecutionId);
  const hasInput = Boolean((prompt || '').trim() || surface);
  return { blocked, activeExecutionId, canSubmit: hasInput && !pending && !blocked };
}
